import { gql } from "@apollo/client";

// id: ID
// right_id: 権利
// start_at: 有効化日時
// end_at: 失効日時
// period_type: 期限種別
// review_flag: レビューフラグ
// suspend_flag: 一時停止フラグ
// suspend_reason: 一時停止理由
// entitled_by: 付与理由
// acquire_at: 獲得日時
// exercised_at: 初回権利行使日時
// exercise_duration: 権利行使有効期間
// exercisable_start_at: 初回権利行使可能開始日時
// exercisable_end_at: 初回権利行使可能終了日時

export const typeDef = gql`
  type Entitlement {
    id: ID!
    user_id: Int
    right_id: Int
    start_at: String
    end_at: String
    exercised_at: String
    exercise_duration: Int
    exercise_duration_unit: Int
    exercisable_start_at: String
    exercisable_end_at: String
    entitled_by: String
    suspend_flag: Boolean
  }

  type Query {
    entitlements(metaId: Int): [Entitlement] @cacheControl(maxAge: 0)
    userEntitlements: [Entitlement] @cacheControl(maxAge: 0)
  }
`;

export const resolvers = {
  Query: {
    entitlements: async (_parent, { metaId }, { dataSources }) => {
      try {
        const { entitlements } = await dataSources.user.entitlementsFromMeta(
          metaId
        );
        return entitlements;
      } catch (e) {
        return null;
      }
    },
    userEntitlements: async (_parent, _args, { req, dataSources }) => {
      if (req.userToken) {
        const { entitlements } = await dataSources.user.entitlements();
        return entitlements;
      } else {
        return null;
      }
    },
  },
  Entitlement: {
    id: (entitlment) => entitlment.entitlement_id,
  },
};
